import {buildFilterUrl} from './filter-seo-url.js';

export default function formFilter({main, on, elm, state}) {
    const catalogEl = document.querySelector('.catalog');
    let filterState = '';

    main(_ => {
        const filters = _selectedFilters();
        filterState = JSON.stringify(filters);
        history.replaceState({...history.state, f: filters}, '', window.location.href);
        on('change', '[data-filter]', onChange);
		window.addEventListener('popstate', popState)
    });

    const onChange = async function (e) {
		const filters = _getFilters(e.target);

        let newFilterState = JSON.stringify(filters);
        if (newFilterState === filterState) return;

        filterState = newFilterState;

		await _filterCatalog(filters);
    };

	const popState = async function(e) {
		const filters = e.state?.f || {};
		await _filterCatalog(filters, false);
		filterState = JSON.stringify(filters);
	};

	const _getFilters = (target) => {
		const filters = [...elm.querySelectorAll('[data-filter]')];

		if (target.dataset.filter === '6') {
			filters
				.filter(el => el.dataset.filter !== '6')
				.forEach((el) => {
					el.choices?.clearChoices(true, true);
				});
		}

		if (target.dataset.filter === '2') {
			filters
				.filter(el => el.dataset.filter !== '6' && el.dataset.filter !== '2')
				.forEach((el) => {
					el.choices?.clearChoices(true, true);
				});
		}

		return _selectedFilters();
	};

	const _selectedFilters = () => {
		const selectedFilters = elm.querySelectorAll('[data-filter] option[selected]:not([value=""])');

		return [...selectedFilters].reduce((acc, el) => {
			const group = el.parentElement.dataset.filter;
			acc[group] = el.value;
			return acc;
		}, {});
	};

	const _filterCatalog = async function (filters, pushHistory = true) {
		const {source, category_id, language_id, category_url} = state.get();
		const loader = document.createElement('div');

		loader.classList.add('lmask');
		catalogEl.insertAdjacentElement('afterbegin', loader);

		const params = new URLSearchParams({
			route: `extension/evasota/module/catalog_filter.${source}`,
			category_id,
			language_id
		});

		Object.entries(filters).forEach(([group, value]) => {
			params.append(`filters[${group}]`, value);
		});

		try {
			const response = await fetch(`index.php?${params}`);

			if (!response.ok) throw new Error(`Response status: ${response.status}`);

			const result = await response.json();
			catalogEl.innerHTML = result[`${source}_list`];

			Object.entries(result.filters).forEach(([key, filter]) => {
				const choices = elm.querySelector(`[data-filter="${key}"]`).closest('select-choices').choices;

				choices.setChoices(filter.values, 'filter_id', 'name', true, false, true);
				if (Object.prototype.hasOwnProperty.call(filters, key)) {
					choices.setChoiceByValue(String(filters[key]));
				}
			});

			if (pushHistory) {
				_syncHistory(filters, category_url, result.filter_seo);
			}
		} catch (e) {
			alert(`Error: ${e.message}`);
		} finally {
			loader?.remove();
		}
	};

	const _syncHistory = (filters, categoryUrl, filterSeo) => {
		let url;
		try {
			const resolved = new URL(filterSeo?.url, window.location.href);
			if (typeof filterSeo?.url === 'string' && filterSeo.url !== ''
				&& resolved.origin === window.location.origin && !resolved.username && !resolved.password
				&& ['http:', 'https:'].includes(resolved.protocol)) {
				url = resolved.href;
			}
		} catch (_) { /* Older responses keep using the existing builder. */ }
		url ??= buildFilterUrl({
			categoryUrl,
			filters,
			meta: filterSeo || {}
		});

		history.pushState({f: filters}, '', url);
	};
};

export const model = {};
